import { environment } from "../../../config";

export class LoggerService {


  static log(message: string, stuff?: unknown) {
    
    if (!environment.production) {
      console.log(message, stuff);
    }
  }

  static error(message: string, error: unknown) {
    if (!environment.production) {
      console.error(message, error);
    }
  }
}